(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f9e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f9e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("35vl8", function(module, exports) {

$parcel$export(module.exports, "_", () => $23fa262fa15998fa$export$581ff339ea0ba762);

var $gURtr = parcelRequire("gURtr");
function $23fa262fa15998fa$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $gURtr._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("gURtr", function(module, exports) {

$parcel$export(module.exports, "_define_property", () => $c50b5b1b2c8d5b56$export$1e71eb4bef00f6b0);
$parcel$export(module.exports, "_", () => $c50b5b1b2c8d5b56$export$1e71eb4bef00f6b0);
function $c50b5b1b2c8d5b56$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("dHnPu", function(module, exports) {

$parcel$export(module.exports, "_", () => $9f91c68e8db142b6$export$7c398597f8905a1);
function $9f91c68e8db142b6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9f91c68e8db142b6$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9f91c68e8db142b6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9f91c68e8db142b6$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("jirw5", function(module, exports) {
$parcel$export(module.exports, "convertError", () => (parcelRequire("1KQR0")).convertError);
$parcel$export(module.exports, "ERROR_REASONS", () => (parcelRequire("1KQR0")).ERROR_REASONS);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("1KQR0")).SentryError);
$parcel$export(module.exports, "CloseModalEvent", () => (parcelRequire("cPQKd")).CloseModalEvent);
$parcel$export(module.exports, "createConnection", () => (parcelRequire("cPQKd")).createConnection);
$parcel$export(module.exports, "Event", () => (parcelRequire("cPQKd")).Event);
$parcel$export(module.exports, "eventFactory", () => (parcelRequire("cPQKd")).eventFactory);
$parcel$export(module.exports, "OpenModalCompleteEvent", () => (parcelRequire("cPQKd")).OpenModalCompleteEvent);
$parcel$export(module.exports, "OpenModalEvent", () => (parcelRequire("cPQKd")).OpenModalEvent);
$parcel$export(module.exports, "OpenPopupBlockedEvent", () => (parcelRequire("cPQKd")).OpenPopupBlockedEvent);
$parcel$export(module.exports, "OpenPopupCompleteEvent", () => (parcelRequire("cPQKd")).OpenPopupCompleteEvent);
$parcel$export(module.exports, "OpenPopupErrorEvent", () => (parcelRequire("cPQKd")).OpenPopupErrorEvent);
$parcel$export(module.exports, "OpenPopupEvent", () => (parcelRequire("cPQKd")).OpenPopupEvent);
$parcel$export(module.exports, "PopupQueryStateEvent", () => (parcelRequire("cPQKd")).PopupQueryStateEvent);
$parcel$export(module.exports, "startListening", () => (parcelRequire("cPQKd")).startListening);

$parcel$export(module.exports, "envs", () => (parcelRequire("i6sW2")));
$parcel$export(module.exports, "environments", () => (parcelRequire("8NUDZ")));
$parcel$export(module.exports, "createLogger", () => (parcelRequire("TcUX8")).createLogger);
$parcel$export(module.exports, "urls", () => (parcelRequire("lXV56")));

var $i6sW2 = parcelRequire("i6sW2");

var $8NUDZ = parcelRequire("8NUDZ");
parcelRequire("1KQR0");
parcelRequire("cPQKd");

var $TcUX8 = parcelRequire("TcUX8");

var $lXV56 = parcelRequire("lXV56");

});
parcelRegister("i6sW2", function(module, exports) {

$parcel$export(module.exports, "getWrapperEnv", () => $27ebd642ae71f8d8$export$74ecc4a9bd17e55c);
$parcel$export(module.exports, "getAppEnv", () => $27ebd642ae71f8d8$export$c5f9c10e769dff78);

var $8NUDZ = parcelRequire("8NUDZ");
const $27ebd642ae71f8d8$export$74ecc4a9bd17e55c = (0, $8NUDZ.environmentMapper)({
    "https://localhost.corp.adobe.com:8080": (0, $8NUDZ.ENVIRONMENTS).local,
    "https://auth-light-sample.identity-stage.adobe.com": (0, $8NUDZ.ENVIRONMENTS).stage,
    "https://auth-light-sample.identity-prestage.adobe.com": (0, $8NUDZ.ENVIRONMENTS).prestage,
    "https://auth-light-sample.identity-preprod.adobe.com": (0, $8NUDZ.ENVIRONMENTS).preprod
});
const $27ebd642ae71f8d8$export$c5f9c10e769dff78 = (0, $8NUDZ.environmentMapper)({
    "https://localhost.corp.adobe.com:25000": (0, $8NUDZ.ENVIRONMENTS).local,
    "https://auth-light.identity-stage.adobe.com": (0, $8NUDZ.ENVIRONMENTS).stage,
    "https://auth-light.identity-prestage.adobe.com": (0, $8NUDZ.ENVIRONMENTS).stage,
    "https://auth-light.identity-preprod.adobe.com": (0, $8NUDZ.ENVIRONMENTS).prod
});

});
parcelRegister("8NUDZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ENVIRONMENTS", () => $84ff205a3f4950d6$export$ad0fa068a57bdc3a);
$parcel$export(module.exports, "environmentMapper", () => $84ff205a3f4950d6$export$426337ee9481be56);
$parcel$export(module.exports, "byEnvironment", () => $84ff205a3f4950d6$export$c8619508fe34dae4);
$parcel$export(module.exports, "default", () => $84ff205a3f4950d6$export$2e2bcd8739ae039);
const $84ff205a3f4950d6$export$ad0fa068a57bdc3a = {
    local: "local",
    stage: "stage",
    prestage: "prestage",
    preprod: "preprod",
    prod: "prod"
};
function $84ff205a3f4950d6$export$426337ee9481be56(map) {
    return (url = window.origin)=>{
        var _map_url;
        return (_map_url = map[url]) !== null && _map_url !== void 0 ? _map_url : $84ff205a3f4950d6$export$ad0fa068a57bdc3a.prod;
    };
}
const $84ff205a3f4950d6$var$isEnvironment = (getEnvironment)=>(env)=>{
        return getEnvironment() === env;
    };
function $84ff205a3f4950d6$export$c8619508fe34dae4(getEnvironment) {
    return function byEnvironment(envToFnMap) {
        const env = getEnvironment();
        return envToFnMap[env]();
    };
}
function $84ff205a3f4950d6$export$2e2bcd8739ae039(getEnvironment) {
    return {
        isEnvironment: $84ff205a3f4950d6$var$isEnvironment(getEnvironment),
        byEnvironment: $84ff205a3f4950d6$export$c8619508fe34dae4(getEnvironment)
    };
}

});


parcelRegister("1KQR0", function(module, exports) {

$parcel$export(module.exports, "ERROR_REASONS", () => $dda3e7279636707e$export$85b027bf1c0c3c10);
$parcel$export(module.exports, "SentryError", () => $dda3e7279636707e$export$5949942ba2a7c0e2);
$parcel$export(module.exports, "convertError", () => $dda3e7279636707e$export$f555a51577ce160);
const $dda3e7279636707e$export$85b027bf1c0c3c10 = {
    undefined: "undefined",
    critical: "critical",
    generic: "generic",
    unrecoverable: "unrecoverable"
};
function $dda3e7279636707e$var$toStringError(error) {
    if (error instanceof $dda3e7279636707e$export$5949942ba2a7c0e2) return error.toString();
    if (error instanceof Error) {
        const message = error.message ? `: ${error.message}` : "";
        return error.name + message;
    }
    return "";
}
class $dda3e7279636707e$export$5949942ba2a7c0e2 extends Error {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            stack: this.stack
        };
    }
    toString() {
        const error = `${this.name}: ${this.message}`;
        const originalErrorString = $dda3e7279636707e$var$toStringError(this.originalError).replaceAll("\n", "\n	");
        return `${error}\n\t<- ${originalErrorString}`;
    }
    get name() {
        return this.type;
    }
    get stack() {
        var _this_originalError;
        var _this_originalError_stack;
        return (_this_originalError_stack = (_this_originalError = this.originalError) === null || _this_originalError === void 0 ? void 0 : _this_originalError.stack) !== null && _this_originalError_stack !== void 0 ? _this_originalError_stack : this.stack;
    }
    static extendError(sentryError, originalError) {
        if (originalError && originalError instanceof Error) sentryError.originalError = originalError;
        return sentryError;
    }
    static generic(originalError) {
        const error = new $dda3e7279636707e$export$7d465be8efa67280();
        return $dda3e7279636707e$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    static critical(causeMessage, originalError) {
        const error = new $dda3e7279636707e$export$4b42a7a78fede561(causeMessage);
        return $dda3e7279636707e$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    static unrecoverable(causeMessage, originalError) {
        const error = new $dda3e7279636707e$export$58a7ae465253b2fa(causeMessage);
        return $dda3e7279636707e$export$5949942ba2a7c0e2.extendError(error, originalError);
    }
    constructor(...args){
        super(...args);
        this.type = $dda3e7279636707e$export$85b027bf1c0c3c10.undefined;
        this.cause = "";
    }
}
class $dda3e7279636707e$export$7d465be8efa67280 extends $dda3e7279636707e$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $dda3e7279636707e$export$85b027bf1c0c3c10.generic;
    }
}
class $dda3e7279636707e$export$4b42a7a78fede561 extends $dda3e7279636707e$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $dda3e7279636707e$export$85b027bf1c0c3c10.critical;
    }
}
class $dda3e7279636707e$export$58a7ae465253b2fa extends $dda3e7279636707e$export$5949942ba2a7c0e2 {
    constructor(...args){
        super(...args);
        this.type = $dda3e7279636707e$export$85b027bf1c0c3c10.unrecoverable;
    }
}
function $dda3e7279636707e$export$f555a51577ce160(input) {
    if (input instanceof $dda3e7279636707e$export$5949942ba2a7c0e2) return input;
    if (input instanceof Error) return $dda3e7279636707e$export$5949942ba2a7c0e2.generic(input);
    return $dda3e7279636707e$export$5949942ba2a7c0e2.generic(new Error(String(input)));
}

});

parcelRegister("cPQKd", function(module, exports) {

$parcel$export(module.exports, "Event", () => $31111059b1ca0653$export$d61e24a684f9e51);
$parcel$export(module.exports, "OpenPopupEvent", () => $31111059b1ca0653$export$47edff89ee5eefdb);
$parcel$export(module.exports, "OpenModalEvent", () => $31111059b1ca0653$export$b9a2c15ca74dee47);
$parcel$export(module.exports, "CloseModalEvent", () => $31111059b1ca0653$export$4518ed92bbb25c89);
$parcel$export(module.exports, "OpenModalCompleteEvent", () => $31111059b1ca0653$export$6fdc11b9e9b0a645);
$parcel$export(module.exports, "OpenPopupCompleteEvent", () => $31111059b1ca0653$export$6ddaf5c7fdb615c5);
$parcel$export(module.exports, "OpenPopupBlockedEvent", () => $31111059b1ca0653$export$43a7920667fb5990);
$parcel$export(module.exports, "OpenPopupErrorEvent", () => $31111059b1ca0653$export$aa36cdda8cc1d9c0);
$parcel$export(module.exports, "PopupQueryStateEvent", () => $31111059b1ca0653$export$9b94066e3b15bd87);
$parcel$export(module.exports, "createConnection", () => $31111059b1ca0653$export$f28ca1a95bdaacaa);
$parcel$export(module.exports, "startListening", () => $31111059b1ca0653$export$5a3c9ae1fa6d7e61);
$parcel$export(module.exports, "eventFactory", () => $31111059b1ca0653$export$c9526fa4526c2c60);

var $1KQR0 = parcelRequire("1KQR0");
function $31111059b1ca0653$export$38cf933889b055d9(eventStr) {
    const prefixLength = eventStr.indexOf("-");
    const metaDataLength = eventStr.indexOf(":");
    const event = eventStr.substring(0, prefixLength);
    const side = eventStr.substring(prefixLength + 1, metaDataLength);
    const data = eventStr.substring(metaDataLength + 1);
    return {
        event: event,
        side: side,
        data: data
    };
}
class $31111059b1ca0653$export$d61e24a684f9e51 {
    setData(data) {
        if (data) return $31111059b1ca0653$export$d61e24a684f9e51.create({
            name: this.name,
            side: this.side,
            data: data
        });
        else return this;
    }
    compareTo(event) {
        return this.name === event.name && this.side === event.side;
    }
    of(base) {
        return this.compareTo(base);
    }
    toString() {
        return JSON.stringify(this);
    }
    static fromString(eventStr) {
        if (typeof eventStr !== "string") throw new TypeError("Event: Event couldn't be created. Invalid value.");
        const parse = JSON.parse(eventStr);
        if (parse && Object.prototype.hasOwnProperty.call(parse, "side") && Object.prototype.hasOwnProperty.call(parse, "name")) return new $31111059b1ca0653$export$d61e24a684f9e51(JSON.parse(eventStr));
        else throw new TypeError("Event: Event incorrectly formatted. Missing side or name.");
    }
    static parse(eventStr, assertedEvent) {
        const event = this.fromString(eventStr);
        if (event.compareTo(assertedEvent)) return event;
        else return null;
    }
    static create(params) {
        return new $31111059b1ca0653$export$d61e24a684f9e51(params);
    }
    constructor({ name: name, side: side, data: data }){
        this.name = name;
        this.side = side;
        this.data = data;
    }
}
const $31111059b1ca0653$export$9071af2ede914ef4 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "init",
    side: "app"
});
const $31111059b1ca0653$export$6a03e30751fc8429 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "response",
    side: "wrapper",
    data: {}
});
const $31111059b1ca0653$export$91f51023bb6bac2f = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "complete",
    side: "app"
});
const $31111059b1ca0653$export$c4a23014fbd7877d = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "error",
    side: "app",
    data: (0, $1KQR0.SentryError).unrecoverable("Unknown error.")
});
const $31111059b1ca0653$export$47edff89ee5eefdb = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "open-popup",
    side: "app",
    data: ""
});
const $31111059b1ca0653$export$b9a2c15ca74dee47 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "on-modal-open",
    side: "proxy",
    data: {
        dimensions: {
            height: 550,
            width: 400
        },
        reason: "unknown"
    }
});
const $31111059b1ca0653$export$4518ed92bbb25c89 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "on-modal-close",
    side: "proxy"
});
const $31111059b1ca0653$export$6fdc11b9e9b0a645 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "open-modal-complete",
    side: "wrapper"
});
const $31111059b1ca0653$export$6ddaf5c7fdb615c5 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "open-popup-complete",
    side: "wrapper"
});
const $31111059b1ca0653$export$43a7920667fb5990 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "open-popup-blocked",
    side: "wrapper"
});
const $31111059b1ca0653$export$aa36cdda8cc1d9c0 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "open-popup-error",
    side: "popup",
    data: ""
});
const $31111059b1ca0653$export$9b94066e3b15bd87 = $31111059b1ca0653$export$d61e24a684f9e51.create({
    name: "query-state",
    side: "popup",
    data: ""
});
function $31111059b1ca0653$export$f28ca1a95bdaacaa(targetOrigin, targetWindow = window.parent) {
    return new Promise((resolve, reject)=>{
        if (!targetOrigin) reject((0, $1KQR0.SentryError).unrecoverable("Invalid target origin."));
        // Send Init event and second port to establish connection
        const channel = new MessageChannel();
        targetWindow.postMessage($31111059b1ca0653$export$9071af2ede914ef4.toString(), targetOrigin, [
            channel.port2
        ]);
        // Wait for ResponseEvent from Wrapper
        channel.port1.onmessage = function(e) {
            const response = $31111059b1ca0653$export$d61e24a684f9e51.parse(e.data, $31111059b1ca0653$export$6a03e30751fc8429);
            if (response) {
                channel.port1.postMessage($31111059b1ca0653$export$91f51023bb6bac2f.toString());
                // Resolve with Wrapper data and port
                resolve({
                    port: channel.port1,
                    channel: channel,
                    state: response.data
                });
            } else reject($31111059b1ca0653$export$c4a23014fbd7877d.setData((0, $1KQR0.SentryError).unrecoverable("Wrong wrapper response.")));
        };
    });
}
function $31111059b1ca0653$export$9d816695ec3452c1(allowedOrigin) {
    return new Promise((resolve, reject)=>{
        window.addEventListener("message", function listener(e) {
            if (e.origin !== allowedOrigin) return;
            const event = $31111059b1ca0653$export$d61e24a684f9e51.fromString(e.data);
            if (event.of($31111059b1ca0653$export$9071af2ede914ef4)) resolve(e.ports[0]);
            if (event.of($31111059b1ca0653$export$c4a23014fbd7877d)) reject(event);
            window.removeEventListener("message", listener);
        });
    });
}
function $31111059b1ca0653$export$a08fb5cc915b7487(port, state) {
    return new Promise((resolve, reject)=>{
        // Wait for Complete event
        port.onmessage = function(e) {
            const event = $31111059b1ca0653$export$d61e24a684f9e51.parse(e.data, $31111059b1ca0653$export$91f51023bb6bac2f);
            if (event) resolve(port);
            else reject($31111059b1ca0653$export$c4a23014fbd7877d.setData((0, $1KQR0.SentryError).unrecoverable("Invalid Sentry reponse to the connection.")));
        };
        // Send Response event
        $31111059b1ca0653$export$6a03e30751fc8429.data = state;
        port.postMessage($31111059b1ca0653$export$6a03e30751fc8429.toString());
    });
}
function $31111059b1ca0653$export$5a3c9ae1fa6d7e61(port) {
    const eventEmitter = new $31111059b1ca0653$export$4fae95256245c8c0();
    port.onmessage = function(event) {
        eventEmitter.broadcast($31111059b1ca0653$export$d61e24a684f9e51.fromString(event.data));
    };
    port.onmessageerror = function() {
        eventEmitter.broadcast($31111059b1ca0653$export$c4a23014fbd7877d.setData((0, $1KQR0.SentryError).unrecoverable("Port message error.")));
    };
    window.addEventListener("storage", ({ key: key, newValue: newValue })=>{
        try {
            if (key === "popupEvent" && newValue) {
                const event = $31111059b1ca0653$export$d61e24a684f9e51.fromString(newValue);
                if (event.of($31111059b1ca0653$export$9b94066e3b15bd87)) {
                    const returnEvent = $31111059b1ca0653$export$d61e24a684f9e51.fromString(event.data);
                    eventEmitter.broadcast(returnEvent);
                }
            }
        } catch (e) {
            console.error(e);
        } finally{
            localStorage.removeItem("popupEvent");
        }
    });
    const eventScheduler = new $31111059b1ca0653$export$e0c335d02293e8fa(eventEmitter);
    return function() {
        return eventScheduler;
    };
}
class $31111059b1ca0653$export$4fae95256245c8c0 {
    get numListeners() {
        return this.listeners.size;
    }
    add(listener) {
        this.listeners.add(listener);
    }
    remove(listener) {
        this.listeners.delete(listener);
    }
    broadcast(event) {
        this.listeners.forEach((listener)=>{
            listener.emit(event);
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}
class $31111059b1ca0653$export$e0c335d02293e8fa {
    subscribe(fn) {
        const listener = new $31111059b1ca0653$export$3291343375ee8b92(fn);
        this.emitter.add(listener);
        return ()=>{
            this.emitter.remove(listener);
        };
    }
    once(fn) {
        let disposer;
        const promise = new Promise((res)=>{
            disposer = this.subscribe((event)=>res(event));
        });
        promise.catch(()=>disposer());
        if (fn) return promise.then((event)=>fn(event)).then(()=>disposer());
        else return promise;
    }
    listenFor(listenedEvent) {
        return new Promise((res, rej)=>{
            const disposer = this.subscribe((event)=>{
                if (listenedEvent.compareTo(event)) {
                    res(event);
                    disposer();
                }
            });
        });
    }
    constructor(emitter){
        this.emitter = emitter;
    }
}
class $31111059b1ca0653$export$3291343375ee8b92 {
    emit(event) {
        this.listener(event);
    }
    constructor(listener){
        this.listener = listener;
    }
}
function $31111059b1ca0653$export$c9526fa4526c2c60(port) {
    return (event)=>(data)=>{
            event.data = data;
            port.postMessage(event.toString());
            return null;
        };
}

});

parcelRegister("TcUX8", function(module, exports) {

$parcel$export(module.exports, "createLogger", () => $cc27d894ae90573c$export$fe2e61603b61130d);

var $8NUDZ = parcelRequire("8NUDZ");
function $cc27d894ae90573c$export$fe2e61603b61130d(getEnv, clientId, relay = "", name = "default") {
    const env = (0, $8NUDZ.byEnvironment)(getEnv);
    const endpoint = env({
        [(0, $8NUDZ.ENVIRONMENTS).local]: ()=>"https://localhost.corp.adobe.com:8081/signin",
        [(0, $8NUDZ.ENVIRONMENTS).stage]: ()=>"https://auth-stg1.services.adobe.com/signin/v1/audit",
        [(0, $8NUDZ.ENVIRONMENTS).prestage]: ()=>"https://auth-stg1.services.adobe.com/signin/v1/audit",
        [(0, $8NUDZ.ENVIRONMENTS).preprod]: ()=>"https://auth.services.adobe.com/signin/v1/audit",
        [(0, $8NUDZ.ENVIRONMENTS).prod]: ()=>"https://auth.services.adobe.com/signin/v1/audit"
    });
    const envName = env({
        [(0, $8NUDZ.ENVIRONMENTS).local]: ()=>"susi-light-local",
        [(0, $8NUDZ.ENVIRONMENTS).stage]: ()=>"susi-light-stage",
        [(0, $8NUDZ.ENVIRONMENTS).prestage]: ()=>"susi-light-prestage",
        [(0, $8NUDZ.ENVIRONMENTS).preprod]: ()=>"susi-light-preprod",
        [(0, $8NUDZ.ENVIRONMENTS).prod]: ()=>"susi-light-prod"
    });
    return function logger(message) {
        return fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-IMS-CLIENTID": clientId,
                "X-DEBUG-ID": relay
            },
            body: JSON.stringify({
                name: name,
                envName: envName,
                clientId: clientId,
                message: message
            })
        }).catch((e)=>{});
    };
}

});

parcelRegister("lXV56", function(module, exports) {

$parcel$export(module.exports, "getApiUrl", () => $ef4cf796d3c6ad94$export$1b98eaf73d37f034);
$parcel$export(module.exports, "getFederatedUrl", () => $ef4cf796d3c6ad94$export$f952767a492cb9b4);
$parcel$export(module.exports, "getAuthServicesUrl", () => $ef4cf796d3c6ad94$export$f59a4c477164a56a);
$parcel$export(module.exports, "getAdobeidServicesUrl", () => $ef4cf796d3c6ad94$export$b4f94fd2634bbbc0);
$parcel$export(module.exports, "getAppUrl", () => $ef4cf796d3c6ad94$export$7086db7f8cfa1126);
$parcel$export(module.exports, "getPopupUrl", () => $ef4cf796d3c6ad94$export$fb180f11d351b294);
$parcel$export(module.exports, "sentryUrl", () => $ef4cf796d3c6ad94$export$c0be0235fa958cd7);
$parcel$export(module.exports, "create", () => $ef4cf796d3c6ad94$export$185802fd694ee1f5);

var $8NUDZ = parcelRequire("8NUDZ");
function $ef4cf796d3c6ad94$export$1b98eaf73d37f034(getEnvironment) {
    return ()=>(0, $8NUDZ.byEnvironment)(getEnvironment)({
            [(0, $8NUDZ.ENVIRONMENTS).local]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $8NUDZ.ENVIRONMENTS).stage]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $8NUDZ.ENVIRONMENTS).prestage]: ()=>"https://ims-na1-stg1.adobelogin.com",
            [(0, $8NUDZ.ENVIRONMENTS).preprod]: ()=>"https://ims-na1.adobelogin.com",
            [(0, $8NUDZ.ENVIRONMENTS).prod]: ()=>"https://ims-na1.adobelogin.com"
        });
}
function $ef4cf796d3c6ad94$export$f952767a492cb9b4(getEnvironment) {
    return ()=>(0, $8NUDZ.byEnvironment)(getEnvironment)({
            [(0, $8NUDZ.ENVIRONMENTS).local]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).stage]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).prestage]: ()=>"https://federatedid-na1-stg1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).preprod]: ()=>"https://federatedid-na1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).prod]: ()=>"https://federatedid-na1.services.adobe.com"
        });
}
function $ef4cf796d3c6ad94$export$f59a4c477164a56a(getEnvironment) {
    return ()=>(0, $8NUDZ.byEnvironment)(getEnvironment)({
            [(0, $8NUDZ.ENVIRONMENTS).local]: ()=>"http://localhost.corp.adobe.com:3000",
            [(0, $8NUDZ.ENVIRONMENTS).stage]: ()=>"https://auth-stg1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).prestage]: ()=>"https://auth-stg1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).preprod]: ()=>"https://auth.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).prod]: ()=>"https://auth.services.adobe.com"
        });
}
function $ef4cf796d3c6ad94$export$b4f94fd2634bbbc0(getEnvironment) {
    return ()=>(0, $8NUDZ.byEnvironment)(getEnvironment)({
            [(0, $8NUDZ.ENVIRONMENTS).local]: ()=>"http://localhost.corp.adobe.com:3000",
            [(0, $8NUDZ.ENVIRONMENTS).stage]: ()=>" https://adobeid-na1-stg1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).prestage]: ()=>"https://adobeid-na1-stg1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).preprod]: ()=>"https://adobeid-na1.services.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).prod]: ()=>"https://adobeid-na1.services.adobe.com"
        });
}
function $ef4cf796d3c6ad94$export$7086db7f8cfa1126(getEnvironment) {
    return ()=>(0, $8NUDZ.byEnvironment)(getEnvironment)({
            [(0, $8NUDZ.ENVIRONMENTS).local]: ()=>"https://localhost.corp.adobe.com:25000",
            [(0, $8NUDZ.ENVIRONMENTS).stage]: ()=>"https://auth-light.identity-stage.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).prestage]: ()=>"https://auth-light.identity-prestage.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).preprod]: ()=>"https://auth-light.identity-preprod.adobe.com",
            [(0, $8NUDZ.ENVIRONMENTS).prod]: ()=>"https://auth-light.identity.adobe.com"
        });
}
function $ef4cf796d3c6ad94$export$fb180f11d351b294(getEnvironment) {
    return ()=>(0, $8NUDZ.byEnvironment)(getEnvironment)({
            [(0, $8NUDZ.ENVIRONMENTS).local]: ()=>"https://localhost.corp.adobe.com:25000/wrapper-popup-helper/index.html",
            [(0, $8NUDZ.ENVIRONMENTS).stage]: ()=>"https://auth-light.identity-stage.adobe.com/wrapper-popup-helper/index.html",
            [(0, $8NUDZ.ENVIRONMENTS).prestage]: ()=>"https://auth-light.identity-prestage.adobe.com/wrapper-popup-helper/index.html",
            [(0, $8NUDZ.ENVIRONMENTS).preprod]: ()=>"https://auth-light.identity-preprod.adobe.com/wrapper-popup-helper/index.html",
            [(0, $8NUDZ.ENVIRONMENTS).prod]: ()=>"https://auth-light.identity.adobe.com/wrapper-popup-helper/index.html"
        });
}
const $ef4cf796d3c6ad94$export$c0be0235fa958cd7 = (getEnvironment, forceStage = false)=>function sentryUrl(variant) {
        const envUrl = $ef4cf796d3c6ad94$export$7086db7f8cfa1126(forceStage ? ()=>(0, $8NUDZ.ENVIRONMENTS).stage : getEnvironment)();
        const url = new URL(envUrl || "");
        url.hash = variant;
        return url;
    };
function $ef4cf796d3c6ad94$export$185802fd694ee1f5(getEnvironment) {
    return {
        getApiUrl: $ef4cf796d3c6ad94$export$1b98eaf73d37f034(getEnvironment),
        getAppUrl: $ef4cf796d3c6ad94$export$7086db7f8cfa1126(getEnvironment),
        getFederatedUrl: $ef4cf796d3c6ad94$export$f952767a492cb9b4(getEnvironment),
        getAuthServicesUrl: $ef4cf796d3c6ad94$export$f59a4c477164a56a(getEnvironment),
        getAdobeidServicesUrl: $ef4cf796d3c6ad94$export$b4f94fd2634bbbc0(getEnvironment),
        getPopupUrl: $ef4cf796d3c6ad94$export$fb180f11d351b294(getEnvironment),
        sentryUrl: $ef4cf796d3c6ad94$export$c0be0235fa958cd7(getEnvironment)
    };
}

});


})();
//# sourceMappingURL=index.ca4bbc9a.js.map
